import React, { FC, useMemo } from 'react'
import Image, { ImageProps } from 'next/image'

import { VideoProps } from '../Video'
import { RecipeIngredientsProps } from '../RecipeIngredientsSection'
import { FamilyStepProps } from '../Family/RecipeStep'

import * as SC from './styled'

export type StepProps = {
  text?: React.ReactNode
  videoProps?: VideoProps
  imageProps?: ImageProps
  ingredients?: RecipeIngredientsProps[]
  familyStepProps?: FamilyStepProps
}

export type StepCardProps = StepProps & {
  className?: string
}

const StepCard: FC<StepCardProps> = (props) => {
  const { className, text, videoProps, imageProps, ingredients } = props

  const renderIngredients = useMemo(() => {
    return (
      ingredients &&
      ingredients.map((ingredient, index) => (
        <SC.Ingredient key={`ingredient-${index}`}>
          <dt>{ingredient.name}</dt>
          <dd>
            {ingredient.weight && ingredient.units && (
              <>
                <span>{ingredient.units}</span>
                <span>{ingredient.weight}</span>
              </>
            )}
            {!ingredient.weight && ingredient.units && (
              <>
                <span>-</span>
                <span>{ingredient.units}</span>
              </>
            )}
          </dd>
        </SC.Ingredient>
      ))
    )
  }, [ingredients])

  return (
    <SC.Container className={className}>
      {videoProps?.video?.src && <SC.VideoWrapper {...videoProps} />}
      {imageProps?.src && (
        <SC.ImageWrapper>
          <Image {...imageProps} />
        </SC.ImageWrapper>
      )}
      {!videoProps?.video?.src && text && <SC.Text>{text}</SC.Text>}
      {ingredients && ingredients?.length > 0 && (
        <SC.Ingredients>{renderIngredients}</SC.Ingredients>
      )}
    </SC.Container>
  )
}

export default StepCard
